import CustomImage from '../custom-image/CustomImage';
import CardWrapper from './CardWrapper';
import Button from '../button/Button';

export default function CardHero({ card, category, colorIndex }) {
  // console.log('card-post', card);
  if (!card) return null;

  return (
    <CardWrapper
      className="cardHero colorDynamicBg hoverParent"
      colorIndex={colorIndex}
      link={card?.link}
    >
      <div className="cardHero-text">
        {/* {card.heading && <h3 className="cardHero-heading">{card.heading}</h3>} */}
        {card.heading && (
          <h3
            className="cardHero-heading"
            dangerouslySetInnerHTML={{ __html: card.heading }}
          />
        )}

        {card.description && (
          <p className="cardHero-description">{card.description}</p>
        )}

        <Button
          buttonLabel={'Explore'}
          size="small"
          tabIndex={-1}
          aria-hidden="true"
        />
      </div>

      {card.image && (
        <div className="cardHero-media">
          <CustomImage
            image={card.image}
            fill={true}
            sizes={'(max-width: 768px) 100vw, 33vw'}
            // radius
          />
        </div>
      )}
    </CardWrapper>
  );
}
